import * as firebase from 'firebase';
//import 'firebase/analytics';

import appConfig from '../app.config';

export const initialize = () => {
  firebase.initializeApp(appConfig?.firebase);
  firebase.analytics();
};
